var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden)?_c('div',{staticClass:"n-validation-container",class:_vm.validatorClass},[_c('nitrozen-icon',{staticClass:"n-validator-icon",attrs:{"color":_vm.getValidatorIconColor,"name":_vm.validationState,"size":_vm.size}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }